module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-haze-fill-5e2bb046.svg";